module.exports = __webpack_public_path__ + "img/star91.7e3cecbf.jpg";